import React, { useEffect, useState } from 'react'
import { api, auth } from '../lib/api'

const ROLE_LABEL = { admin: '管理员', leader: '售后组长', agent: '售后专员' }
const fmt = (t) => t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : ''

export default function Staff() {
  const [list, setList] = useState([])
  const [teams, setTeams] = useState([])
  const [err, setErr] = useState('')
  const [creating, setCreating] = useState(false)
  const [editing, setEditing] = useState(null)
  const [creatingTeam, setCreatingTeam] = useState(false)

  async function load() {
    try { setList((await api.listStaff()).staff) } catch (e) { setErr(e.message) }
  }
  async function loadTeams() {
    try { setTeams((await api.listTeams()).teams) } catch { /* 下拉用，静默失败 */ }
  }
  useEffect(() => { load(); loadTeams() }, [])

  async function toggleActive(s) {
    try { await api.updateStaff(s.id, { is_active: !s.is_active }); load() } catch (e) { setErr(e.message) }
  }

  return (
    <div>
      <div className="spread" style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 16 }}>团队</h2>
        {auth.isAdmin && <button className="btn btn-sm" onClick={() => setCreatingTeam(true)}>新增团队</button>}
      </div>
      <div className="card" style={{ padding: 16, marginBottom: 24 }}>
        <div className="row" style={{ flexWrap: 'wrap', gap: 8 }}>
          {teams.map(t => <span key={t.id} className="tag">{t.name}</span>)}
          {!teams.length && <span className="small muted">暂无团队</span>}
        </div>
      </div>

      <div className="spread" style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 16 }}>员工列表</h2>
        <button className="btn btn-primary" onClick={() => setCreating(true)}>新增员工账号</button>
      </div>
      <div className="card table-wrap">
        <table>
          <thead>
            <tr><th>姓名</th><th>手机号</th><th>角色</th><th>团队</th><th>创建时间</th><th>状态</th><th>备注</th><th>操作</th></tr>
          </thead>
          <tbody>
            {list.map(s => (
              <tr key={s.id}>
                <td>{s.name}</td>
                <td className="mono">{s.phone}</td>
                <td><span className="tag">{ROLE_LABEL[s.role] || s.role}</span></td>
                <td>{s.team_name || '-'}</td>
                <td className="small muted">{fmt(s.created_at)}</td>
                <td>
                  <span className={s.is_active ? 'tag tag-paid' : 'tag'}>{s.is_active ? '启用' : '停用'}</span>
                </td>
                <td className="small muted">{s.remark}</td>
                <td>
                  <button className="btn-link btn-sm" onClick={() => setEditing(s)}>编辑</button>
                  <button className="btn-link btn-sm" onClick={() => toggleActive(s)}>{s.is_active ? '停用' : '启用'}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!list.length && <div className="empty">暂无员工</div>}
      </div>
      <div className="err">{err}</div>

      {creating && <StaffModal teams={teams} onClose={() => setCreating(false)} onSaved={load} />}
      {editing && <StaffModal staff={editing} teams={teams} onClose={() => setEditing(null)} onSaved={load} />}
      {creatingTeam && <TeamModal staffList={list} onClose={() => setCreatingTeam(false)} onSaved={() => { loadTeams(); load() }} />}
    </div>
  )
}

function TeamModal({ staffList, onClose, onSaved }) {
  const [name, setName] = useState('')
  const [leaderId, setLeaderId] = useState('')
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)
  const leaders = staffList.filter(s => s.role === 'leader')

  async function submit() {
    setSaving(true); setErr('')
    try {
      await api.createTeam({ name, leader_id: leaderId || undefined })
      onSaved(); onClose()
    } catch (e) { setErr(e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>新增团队</h2>
        <div className="field">
          <label>团队名称 *</label>
          <input className="input" value={name} onChange={e => setName(e.target.value)} autoFocus />
        </div>
        <div className="field">
          <label>组长（可选，选中后会把该员工分配进这个团队）</label>
          <select className="select" value={leaderId} onChange={e => setLeaderId(e.target.value)}>
            <option value="">暂不指定</option>
            {leaders.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          {!leaders.length && <div className="small muted" style={{ marginTop: 4 }}>暂无"售后组长"角色的员工，可先建团队，之后在编辑员工时把团队设过来</div>}
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={submit} disabled={saving || !name.trim()}>保存</button>
          <button className="btn" onClick={onClose}>取消</button>
        </div>
        <div className="err">{err}</div>
      </div>
    </div>
  )
}

function StaffModal({ staff, teams, onClose, onSaved }) {
  const isEdit = !!staff
  const [form, setForm] = useState({
    name: staff?.name || '',
    phone: staff?.phone || '',
    password: '',
    role: staff?.role || 'agent',
    team_id: staff?.team_id || '',
    remark: staff?.remark || '',
  })
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)

  async function submit() {
    setSaving(true); setErr('')
    try {
      if (isEdit) {
        await api.updateStaff(staff.id, {
          name: form.name,
          remark: form.remark,
          ...(form.password ? { password: form.password } : {}),
          ...(auth.isAdmin ? { role: form.role, team_id: form.team_id || null } : {}),
        })
      } else {
        await api.createStaff({
          name: form.name, phone: form.phone, password: form.password,
          role: form.role, team_id: form.team_id || undefined, remark: form.remark,
        })
      }
      onSaved(); onClose()
    } catch (e) { setErr(e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>{isEdit ? '编辑员工' : '新增员工账号'}</h2>
        <div className="field">
          <label>姓名 *</label>
          <input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} autoFocus />
        </div>
        <div className="field">
          <label>手机号 *（登录账号）</label>
          <input className="input" value={form.phone} disabled={isEdit} onChange={e => setForm({ ...form, phone: e.target.value })} />
        </div>
        <div className="field">
          <label>{isEdit ? '重置密码（留空则不改）' : '密码 *'}</label>
          <input className="input" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
        </div>
        {auth.isAdmin && (
          <>
            <div className="field">
              <label>角色</label>
              <select className="select" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                <option value="agent">售后专员</option>
                <option value="leader">售后组长</option>
                <option value="admin">管理员</option>
              </select>
            </div>
            <div className="field">
              <label>团队</label>
              <select className="select" value={form.team_id} onChange={e => setForm({ ...form, team_id: e.target.value })}>
                <option value="">未分配</option>
                {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
          </>
        )}
        <div className="field">
          <label>备注</label>
          <input className="input" value={form.remark} onChange={e => setForm({ ...form, remark: e.target.value })} />
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={submit}
            disabled={saving || !form.name || (!isEdit && (!form.phone || !form.password))}>保存</button>
          <button className="btn" onClick={onClose}>取消</button>
        </div>
        <div className="err">{err}</div>
      </div>
    </div>
  )
}
